import React, { useEffect, useState } from "react";
import Breadcrums from "../../../components/breadcrums";
import PageTitle from "../../../components/pageTitle";
import { paymentsGenerateInvoiceBreadcrums } from "../../../constants/breadcrums";
import { paymentsCommands, sectionClass } from "../../../constants/common";
import CommonFilters from "../../../blocks/commonFilters";
import { useSnackbar } from "react-simple-snackbar";
import { listOfEmployees } from "../../../api/consultants-api";
import TanstackTable from "../../../components/TanstackTable";
import { ColumnDef } from "@tanstack/react-table";
import { generateInvoice, generateWeeklyInvoice, getDuplicateInvoiceNumber, getInvoicesData, markVerified, performPaymentAPI } from "../../../api/finance-api";
import { GetClients } from "../../../api/project-api";
import Currency from "react-currency-formatter";
import moment from "moment";
// import { generate } from "@pdfme/generator";
import { FinanceRecord, InvoiceRequestParams } from "../../../model";
import { ExclamationCircleIcon } from "@heroicons/react/solid";
// import ToolTip from "../../../components/ToolTip";

import { NumericFormat } from "react-number-format";

import { Tooltip } from "flowbite-react";
import { getNextInvoiceNumber } from "../../../api/sequence-api";
import { useAuth0 } from "@auth0/auth0-react";
import { nanoid } from "nanoid";

// Use current year for calculation
// const workingDaysPerMonth: number[] = getWorkingDaysPerMonth(new Date().getFullYear());
// console.log(workingDaysPerMonth);

export default function Invoices() {
    const [people, setPeople] = useState<{ entity: string; active?: number }[]>([]);
    const [clients, setClients] = useState<any[]>([]);
    const [openSnackbar] = useSnackbar();
    const [isLoading, setLoading] = React.useState(false);
    const [filter, setFilter] = React.useState(null);
    const [data, setData] = React.useState<FinanceRecord[]>([]);
    const [activeStatus, setActiveStatus] = useState<"all" | "active" | "inactive">("active");
    const [billingPeriod, setBillingPeriod] = useState<"all" | "Weekly" | "Monthly" | "Monthly Itemized">("all");
    const [applyYearFilter, setApplyYearFilter] = useState(true);
    const [duplicateInvoices, setDuplicateInvoices] = useState<any[]>([]);
    const [showUnpaidOnly, setShowUnpaidOnly] = useState(false);
    const [selectedClient, setSelectedClient] = useState<string>("all");

    const { user, isAuthenticated } = useAuth0(); // <-- Call hook here

    const [tableKey, setTableKey] = useState("initial");

    function forceTableRefresh() {
        setTableKey(nanoid());
    }

    useEffect(() => {
        setLoading(true);
        setPeople([]);
        setData([]);
        
        // Load employees
        listOfEmployees()
            .then((data) => setPeople(data))
            .catch((error) => console.error("Error loading employees:", error));
        
        // Load clients
        GetClients()
            .then((data) => {
                console.warn(data);
                setClients(data);
            })
            .catch((error) => console.error("Error loading clients:", error))
            .finally(() => {
                setLoading(false);
            });
    }, []);

    function applyFilters(filters): any {
        setLoading(true);
        setData([]);
        setFilter(filters);

        console.log("Applying filters:", filters);

        getDuplicateInvoiceNumber()
            .then((data) => {
                setDuplicateInvoices(data || []);
                if (data && data.length > 0) {
                    openSnackbar("Duplicate Invoice Numbers found!");
                }
            })
            .catch((error) => {
                setDuplicateInvoices([]);
                console.error("Error fetching duplicate invoice numbers:", error);
            });

        getInvoicesData(filters)
            .then((data) => {
                // console.log(data);
                console.log("Invoice data loaded:", data);
                console.log("Sample row:", data[0]);
                setData(data);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    async function generateInvoiceHandler(params: InvoiceRequestParams): Promise<any> {
        const invoiceNo = await getNextInvoiceNumber();
        console.log(invoiceNo); // e.g., "20250729-001"
        //nextId("INV" + moment.utc().format("YYMMDD-"));
        //nextId("INV" + moment.utc().format("YYMMDD-"));
        params.invoiceNo = invoiceNo;

        const scrollY = window.scrollY;

        console.log("Generating invoice with params:", params);

        // Audit Details
        try {
            // Get current user from Auth0
            let currentUser = "system";
            if (isAuthenticated && user) {
                currentUser = user.name || user.email || "system"; //user.nickname ||
            }

            // Audit Details
            // params.createdBy = currentUser;
            params.updatedBy = currentUser;
        } catch (error) {
            console.error("Error fetching user details:", error);
            params.createdBy = "system"; // Fallback if user details are not available
            params.updatedBy = "system";
        }

        if (params.billingPeriod === "Monthly" || params.billingPeriod === "Monthly Itemized") {
            params.invoiceNo = invoiceNo;
            generateInvoice(params).then((updatedRows) => {
                console.log(updatedRows);

                // Optimistically update local data state
                setData((prevData) =>
                    prevData.map((item) => {
                        console.log("Processing item:", item);
                        const updated = updatedRows.find((u) => u.uuid === item.uuid && params.startDate === item.period_start);
                        if (updated) {
                            const merged = { ...item, ...updated };
                            console.log("Updated item:", merged);
                            return merged;
                        }
                        return item;
                    }),
                );

                if (params.uuid) {
                    openSnackbar("Invoice Generated");
                } else {
                    openSnackbar("Invoices Generated");
                }

                forceTableRefresh();

                // After update (in a setTimeout or useEffect)
                setTimeout(() => {
                    window.scrollTo(0, scrollY);
                }, 0);
            });
        } else if (params.billingPeriod === "Weekly") {
            params.invoiceNo = invoiceNo;
            generateWeeklyInvoice(params).then((r) => {
                console.log(r);
                // getInvoiceSequence();

                // Optimistically update local data state
                setData((prevData) =>
                    prevData.map((item) =>
                        item.uuid === params.uuid && Number(item.calendar_week) === params.week && item.year === moment(params.checkDate).year()
                            ? {
                                  ...item,
                                  invoice_no: params.invoiceNo || "",
                                  _ts_invoice: new Date(), // or the correct value if you have it
                                  // update other fields if needed
                              }
                            : item,
                    ),
                );

                openSnackbar("Weekly Invoice(s) Generated");

                forceTableRefresh();

                // After update (in a setTimeout or useEffect)
                setTimeout(() => {
                    window.scrollTo(0, scrollY);
                }, 0);
            });
        }
    }

    // Move these functions INSIDE the component
    function performVerify(params: InvoiceRequestParams): any {
        params.verified = true;
        params._ts_verify = new Date();
        markVerified(params).then((r) => {
            openSnackbar("Verified Successfully");
            // Optionally refresh data here
        });
    }

    function performPayment(params: InvoiceRequestParams): any {
        // console.log(params);
        // params.verified = true;
        // params._ts_verify = new Date();
        performPaymentAPI(params).then((r) => {
            openSnackbar("Payment Completed.");
            // Optionally refresh data here
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const columns = React.useMemo<ColumnDef<FinanceRecord, any>[]>(
        () => [
            {
                accessorKey: "name",
                header: "Name",
                // cell: (info) => info.getValue(),
                cell: ({ row }) => (
                    <>
                        <span className="font-bold">{row.original.name}</span> <br />
                        <span className="text-xs">{" (" + row.original.pid + ")"}</span>
                    </>
                ),
                enableColumnFilter: false,
                enableGrouping: false,
                // enableSorting: true,
                meta: {
                    cellClassName: "font-bold",
                    className: "font-bold",
                },
                footer: ({ table }) => (
                    <>
                        <span className="font-semibold text-md">Total</span>
                        <br />
                        <span className="text-xs text-gray-600">
                            {new Set(table.getFilteredRowModel().rows.map(row => row.original.name)).size}  employees
                        </span>
                    </>
                ),
            },
            // --- Add this new column below ---
            // FIXME - Hide for now
            // {
            //     accessorKey: "billing_group",
            //     header: "Billing Cycle",
            //     cell: ({ row }) => row.original.billing_period ||  "-",
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     meta: {
            //         cellClassName: "text-left",
            //     },
            // },

            // {
            //     accessorKey: "_d",
            //     header: "D",
            //     cell: ({ row }) => row.original._d || "-",
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     meta: {
            //         cellClassName: "text-left",
            //     },
            // },

            // {
            //     accessorKey: "calendar_week",
            //     header: "Week No.",
            //     cell: ({ row }) => row.original.calendar_week || "-",
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     meta: {
            //         cellClassName: "text-left",
            //     },
            // },

            {
                accessorKey: "period_start",
                header: "Period Start",
                cell: ({ row }) => row.original.period_start || "-",
                enableColumnFilter: false,
                enableGrouping: false,
                meta: {
                    cellClassName: "text-left",
                },
            },

            // {
            //     accessorKey: "period_end",
            //     header: "Period End",
            //     cell: ({ row }) => moment(row.original.period_end).format("YYYY-MM-DD") || "-",
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     meta: {
            //         cellClassName: "text-left",
            //     },
            // },

            {
                accessorKey: "month",
                header: "Invoice Period",
                cell: (info) => info.getValue(),
                enableColumnFilter: false,
                enableGrouping: false,
                // enableSorting: true,
                footer: ({ table }) => <></>,
            },

            // {
            //     accessorKey: "_ts_invoice_due",
            //     header: "Aging",
            //     cell: ({ row, getValue }) => {
            //         const dueDate = getValue();
            //         if (!row.original.invoice_no) return "-";
            //         if (!dueDate) return "-";
            //         const days = moment().diff(moment(dueDate), "days");
            //         const isOverdue = days >= 0;
            //         return (
            //             <span style={{ color: isOverdue ? "red" : "black" }}>
            //                 {isOverdue
            //                     ? `${days} day${days === 1 ? "" : "s"}`
            //                     : `Due in ${Math.abs(days)} day${Math.abs(days) === 1 ? "" : "s"}`}
            //             </span>
            //         );
            //     },
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     enableSorting: true,
            //     footer: ({ table }) => <></>,
            // },

            {
                accessorKey: "_ts_invoice_due",
                header: "Aging",
                cell: ({ row, getValue }) => {
                    // Only show if diff > 0 and invoice_no exists
                    if (!row.original.invoice_no || !(row.original.diff > 0)) return "-";
                    const dueDate = getValue();
                    if (!dueDate) return "-";
                    const days = moment().diff(moment(dueDate), "days");
                    const isOverdue = days >= 0;
                    return <span style={{ color: isOverdue ? "red" : "black" }}>{isOverdue ? `${days} day${days === 1 ? "" : "s"}` : ` ${Math.abs(days)} day${Math.abs(days) === 1 ? "" : "s"}`}</span>;
                },
                enableColumnFilter: false,
                enableGrouping: false,
                enableSorting: true,
                footer: ({ table }) => <></>,
            },

            // FIXME - Hide for now
            {
                accessorKey: "_punched",
                header: "Punched (Days)",
                cell: (info) => info.getValue(),
                enableColumnFilter: false,
                enableGrouping: false,
                // enableSorting: true,
                footer: ({ table }) => <></>,
            },

            // {
            //     accessorKey: "month",
            //     header: "Working Days",
            //     // cell: (info) => info.getValue(),
            //     cell: ({ row, getValue }) => {
            //         const date = moment(row.original._d);
            //         const year = date.year();
            //         const month = date.month(); // 0-based
            //         return getWorkingDaysPerMonth(year)[month] || "-";
            //         // return getEffortsDetails(row?.original) || "-";
            //     },
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     // enableSorting: true,
            //     footer: ({ table }) => <></>,
            // },

            // {
            //     accessorKey: "_d",
            //     header: "D",
            //     cell: (info) => info.getValue(),
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     // enableSorting: true,
            //     footer: ({ table }) => <></>,
            // },

            // {
            //     accessorKey: "billing_period",
            //     header: "Invoice Period",
            //     cell: ({ row }) => (
            //         <>
            //             {row.original.billing_period != "Weekly" && moment(row.original._d).format("MMM-YYYY")}
            //             {row.original.billing_period == "Weekly" && row.original.invoice_no == "" && moment(row.original._d).format("MMM-YYYY")}
            //             {row.original.billing_period == "Weekly" && row.original.invoice_no != "" && "Week-" + moment(row.original._d).week()}
            //         </>
            //     ),
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     // enableSorting: true,
            //     footer: ({ table }) => <>{/* <span className="font-semibold text-md">Total</span> */}</>,
            // },

            {
                accessorKey: "hrs",
                header: "Efforts (Hrs)",
                cell: (info) => Number(info.getValue()) | 0,
                enableGrouping: false,
                enableColumnFilter: false,
                meta: {
                    cellClassName: "text-right",
                },
                footer: ({ table }) => (
                    <>
                        {/* <span className="text-xs font-normal">Total Efforts</span>
                        <br /> */}
                        {/* <span className="text-md thousand-sepera">{table.getFilteredRowModel().rows.reduce((total, row) => total + row.original.hrs, 0)}</span> */}
                        {/* <Currency quantity={Number(table.getFilteredRowModel().rows.reduce((total, row) => total + row.original.hrs, 0)) || 0}  displayType={'text'}  thousandSeparator="," /> */}
                        <NumericFormat value={Number(table.getFilteredRowModel().rows.reduce((total, row) => total + row.original.hrs, 0)) || 0} allowLeadingZeros displayType="text" thousandSeparator="," />
                    </>
                ),
            },

            {
                accessorKey: "prate",
                header: "Rate (USD)",
                // cell: (info) => <Currency quantity={Number(info.getValue()) || 0} currency="USD" />,
                cell: ({ row, getValue }) => {
                    if (row.original.fixed_payment) return <>{<Currency quantity={Number(row.original.fixed_payment) || 0} currency="USD" />} /m</>;
                    //Number(row.original.fixed_payment) ||

                    const rate = getValue();
                    return rate ? <Currency quantity={Number(rate) || 0} currency="USD" /> : "-";
                },
                enableGrouping: false,
                enableColumnFilter: false,
                meta: {
                    cellClassName: "text-right",
                },
            },

            // {
            //     accessorKey: "uuid",
            //     header: "UUID",
            //     cell: (info) => info.getValue(),
            //     // enableHiding: false,
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     // columnVisibility: false,
            //     meta: {
            //         cellClassName: "text-center",
            //     },
            // },

               {
                accessorKey: "deductions",
                header: "Deductions (%)",
                cell: ({ row }) => {
                    const insuranceFee = Number((row.original as any).insurance_fee) || 0;
                    const vmo = Number((row.original as any).vmo) || 0;
                    const totalDeductions = insuranceFee + vmo;
                    return <span>{totalDeductions}%</span>;
                },
                enableColumnFilter: false,
                enableGrouping: false,
                meta: {
                    cellClassName: "text-right",
                },
                
            },

            // {
            //     accessorKey: "deductions",
            //     header: "Deduction Amount (USD)",
            //     cell: ({ row }) => {
            //         const insuranceFee = Number((row.original as any).insurance_fee) || 0;
            //         const vmo = Number((row.original as any).vmo) || 0;

            //         const totalDeductions = insuranceFee + vmo;

            //         return <span>{row.original.bill_wo_deductions * totalDeductions / 100}</span>;
            //     },
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     meta: {
            //         cellClassName: "text-right",
            //     },
                
            // },

            // {
            //     accessorKey: "bill_wo_deductions",
            //     header: "Bill Amount w/o Deductions (USD)",
            //     cell: (info) => <Currency quantity={Number(info.getValue()) || 0} currency="USD" />,
            //     // cell: ({ row }) => (
            //     //     <><Currency quantity={row.original.bill || 0} currency="USD" /> </>
            //     // ),
            //     // enableHiding: false,
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     // columnVisibility: false,
            //     meta: {
            //         cellClassName: "text-right",
            //     },
            //     footer: ({ table }) => (
            //         <>
            //             {/* <span className="text-xs font-normal">Total Bill</span>
            //             <br /> */}
            //             {/* <Currency quantity={Number(table.getFilteredRowModel().rows.reduce((total, row) => total + (row.original.fixed_payroll ? (Number(row.original.fixed_payroll) / getWorkingDaysPerMonth(moment(row.original._d).year())[Number(moment(row.original?._d).month() - 1)]) * Number(row.original?._punched) : row.original.bill), 0)) || 0} currency="USD" /> */}

            //             {/* <Currency quantity={Number(table.getFilteredRowModel().rows.reduce((total, row) => total + row.original.bill, 0)) || 0} currency="USD" /> */}

            //             <Currency
            //                 quantity={table
            //                     .getFilteredRowModel()
            //                     .rows.map((row) => Number(row.original.bill_wo_deductions || 0))
            //                     .filter((val) => !isNaN(val))
            //                     .reduce((total, val) => total + val, 0)}
            //                 currency="USD"
            //             />
            //         </>
            //     ),
            // },


            {
                accessorKey: "bill",
                header: "Bill Amount (USD)",
                cell: (info) => <Currency quantity={Number(info.getValue()) || 0} currency="USD" />,
                // cell: ({ row }) => (
                //     <><Currency quantity={row.original.bill || 0} currency="USD" /> </>
                // ),
                // enableHiding: false,
                enableColumnFilter: false,
                enableGrouping: false,
                // columnVisibility: false,
                meta: {
                    cellClassName: "text-right",
                },
                footer: ({ table }) => (
                    <>
                        {/* <span className="text-xs font-normal">Total Bill</span>
                        <br /> */}
                        {/* <Currency quantity={Number(table.getFilteredRowModel().rows.reduce((total, row) => total + (row.original.fixed_payroll ? (Number(row.original.fixed_payroll) / getWorkingDaysPerMonth(moment(row.original._d).year())[Number(moment(row.original?._d).month() - 1)]) * Number(row.original?._punched) : row.original.bill), 0)) || 0} currency="USD" /> */}

                        {/* <Currency quantity={Number(table.getFilteredRowModel().rows.reduce((total, row) => total + row.original.bill, 0)) || 0} currency="USD" /> */}

                        <Currency
                            quantity={table
                                .getFilteredRowModel()
                                .rows.map((row) => Number(row.original.bill))
                                .filter((val) => !isNaN(val))
                                .reduce((total, val) => total + val, 0)}
                            currency="USD"
                        />
                    </>
                ),
            },
         
            {
                accessorKey: "payment",
                header: "Amount Recieved (USD)",
                cell: (info) => <Currency quantity={Number(info.getValue()) || 0} currency="USD" />,
                // enableHiding: false,
                enableColumnFilter: false,
                enableGrouping: false,
                // columnVisibility: false,
                meta: {
                    cellClassName: "text-right",
                },
                footer: ({ table }) => (
                    <>
                        {/* <span className="text-xs font-normal">Total Payment Recieved</span>
                        <br /> */}
                        {/* <Currency quantity={Number(table.getFilteredRowModel().rows.reduce((total, row) => total + row.original.payment, 0)) || 0} currency="USD" /> */}

                        <Currency
                            quantity={table
                                .getFilteredRowModel()
                                .rows.map((row) => Number(row.original.payment))
                                .filter((val) => !isNaN(val))
                                .reduce((total, val) => total + val, 0)}
                            currency="USD"
                        />
                    </>
                ),
            },

            {
                accessorKey: "diff",
                header: "Balance (USD)",
                cell: (info) => <Currency quantity={Number(info.getValue()) || 0} currency="USD" />,
                // cell: ({ row }) => (
                //     <> <Currency quantity={row.original.diff || 0} currency="USD" /> </>
                // ),
                // (info) => <Currency quantity={Number(info.getValue()) || 0} currency="USD" />,
                // enableHiding: false,
                enableColumnFilter: false,
                enableGrouping: false,
                // columnVisibility: false,
                meta: {
                    cellClassName: "text-right",
                },
                footer: ({ table }) => (
                    <>
                        {/* <Currency quantity={Number(table.getFilteredRowModel().rows.reduce((total, row) => total + row.original.diff, 0)) || 0} currency="USD" /> */}
                        <Currency
                            quantity={table
                                .getFilteredRowModel()
                                .rows.map((row) => Number(row.original.diff))
                                .filter((val) => !isNaN(val))
                                .reduce((total, val) => total + val, 0)}
                            currency="USD"
                        />
                    </>
                ),
            },

            // {
            //     accessorKey: "billPerDay",
            //     header: "Bill Per Day (USD)",
            //     cell: (info) => <Currency quantity={Number(info.getValue()) || 0} currency="USD" />,
            //     // cell: ({ row }) => (
            //     //     <> <Currency quantity={row.original.diff || 0} currency="USD" /> </>
            //     // ),
            //     // (info) => <Currency quantity={Number(info.getValue()) || 0} currency="USD" />,
            //     // enableHiding: false,
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     // columnVisibility: false,
            //     meta: {
            //         cellClassName: "text-right",
            //     },
            //     footer: ({ table }) => (
            //         <>
            //             {/* <Currency quantity={Number(table.getFilteredRowModel().rows.reduce((total, row) => total + row.original.diff, 0)) || 0} currency="USD" /> */}
            //             <Currency
            //                 quantity={table
            //                     .getFilteredRowModel()
            //                     .rows.map((row) => Number(row.original.billPerDay))
            //                     .filter((val) => !isNaN(val))
            //                     .reduce((total, val) => total + val, 0)}
            //                 currency="USD"
            //             />
            //         </>
            //     ),
            // },


            {
                accessorKey: "uuid",
                header: "",
                cell: ({ row }) => (
                    <>
                        {/* && row.original.payment > 0 */}
                        {row.original.uuid && (
                            <>
                                {/* <a target="_blank" href={`/payments/invoice/${row.original.uuid}/${row.original.m}/${row.original.year}`} className="text-blue-600 no-underline hover:text-blue-900 no-line-through">
                                    Verify <span className="sr-only">, {row.original.consultant}</span>
                                </a>
                                {" | "} */}
                                {/* href={`/payments/invoice/${row.original.uuid}/${row.original.m}/${row.original.year}`} */}

                                {/* <b>{row.original.invoice_no}</b>
                                {" | "} */}

                                {!row.original.invoice_no && (
                                    <a
                                        href="#"
                                        onClick={(e) =>
                                            generateInvoiceHandler({
                                                uuid: row.original.uuid,
                                                checkDate: new Date(moment.utc(row.original._d).format("YYYY-MM-DD HH:mm:ss")),
                                                billingPeriod: row.original.billing_period,
                                                week: Number(row.original.calendar_week),
                                                rate: row.original.prate,
                                                startDate: row.original.period_start,
                                                endDate: row.original.period_end,
                                                record: row.original,
                                            })
                                        }
                                        className="text-blue-600 no-underline hover:text-blue-900 no-line-through"
                                    >
                                        Generate Invoice <span className="sr-only">, {row.original.uuid}</span>
                                    </a>
                                )}

                                {row.original.invoice_no && (
                                    <>
                                        {row.original.billing_period !== "Weekly" && (
                                            <Tooltip content="View Invoice" style="dark" placement="left">
                                                <a target="_blank" rel="noreferrer" href={`/payments/invoice/${row.original.uuid}/${row.original.m}/${row.original.year}/${row.original.invoice_no}/${row.original._d}`} className="text-blue-600 no-underline hover:text-blue-900 no-line-through">
                                                    View Invoice <span className="sr-only">, {row.original.invoice_no}</span>
                                                </a>
                                            </Tooltip>
                                        )}

                                        {row.original.billing_period === "Weekly" && (
                                            <Tooltip content="View Invoice" style="dark" placement="left">
                                                <a target="_blank" rel="noreferrer" href={`/payments/invoice/${row.original.uuid}/${moment(row.original._d).week()}/${row.original.m}/${row.original.year}/${row.original.invoice_no}/${row.original._d}`} className="text-blue-600 no-underline hover:text-blue-900 no-line-through">
                                                    View Invoice <span className="sr-only">, {row.original.invoice_no}</span>
                                                </a>
                                            </Tooltip>
                                        )}
                                    </>
                                )}
                            </>
                        )}

                        {!row.original.uuid && (
                            <span className="text-center">
                                {" "}
                                <div className="block text-sm">
                                    {/*
                                     */}
                                    {/* <ToolTip tooltip="UUID Missing!"></ToolTip> */}
                                    <Tooltip content="UUID missing, please contact administrator!" style="dark" placement="left">
                                        <ExclamationCircleIcon className="w-5 h-5 text-center text-red-500" data-tooltip-target="tooltip-default" />
                                    </Tooltip>
                                </div>
                                {/* <button data-tooltip-target="tooltip-default" type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                    Default tooltip
                                </button>
                                <div id="tooltip-default" role="tooltip" className="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700">
                                    Tooltip content
                                    <div className="tooltip-arrow" data-popper-arrow></div>
                                </div> */}
                            </span>
                        )}
                    </>
                ),
                // enableHiding: false,
                enableColumnFilter: false,
                enableGrouping: false,
                // columnVisibility: false,
                meta: {
                    cellClassName: "text-center",
                },
            },
            {
                accessorKey: "actions",
                header: "Actions",
                cell: ({ row }) => (
                    <>
                        {row.original.uuid && row.original.invoice_no && row.original.diff > 0 && (
                            <div className="flex">
                                {/* Verify Button */}
                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        performVerify({
                                            uuid: row.original.uuid,
                                            checkDate: moment(row.original._d).toDate(),
                                        });
                                    }}
                                    className="text-blue-600 no-underline hover:text-blue-900 no-line-through"
                                    title="Verify"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 019 9v.375M10.125 2.25A3.375 3.375 0 0113.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 013.375 3.375M9 15l2.25 2.25L15 12" />
                                    </svg>
                                </a>
                                {/* Payment Button */}
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.preventDefault();

                                        performPayment({
                                            uuid: row.original.uuid,
                                            checkDate: moment(row.original._d).toDate(),
                                            rate: row.original.prate,
                                            invoiceNo: row.original.invoice_no,
                                            payment: null, // Let the API calculate rate * hrs for each day
                                            billingPeriod: row.original.billing_period,
                                        });
                                    }}
                                    className="p-0 ml-3 text-blue-600 no-underline bg-transparent border-0 hover:text-blue-900 no-line-through"
                                    title="Pay"
                                    style={{ cursor: "pointer" }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z"
                                        />
                                    </svg>
                                </button>
                            </div>
                        )}
                    </>
                ),
                enableColumnFilter: false,
                enableGrouping: false,
                meta: {
                    cellClassName: "text-right",
                },
            },
            {
                accessorKey: "invoice_no",
                header: "Invoice No.",
                // cell: (info) => info.getValue() || "-",
                cell: (info) => (
                    <span className="truncate block max-w-[220px]" title={info.getValue() || "-"}>
                        {info.getValue() || "-"}
                    </span>
                ),
                enableColumnFilter: false,
                enableGrouping: false,
                // enableSorting: true,
                footer: ({ table }) => <>{/* <span className="font-semibold text-md">Total</span> */}</>,
            },

            {
                accessorKey: "_ts_invoice",
                header: "Invoice Dt.",
                cell: ({ row, getValue }) => {
                    // Only show date if invoice_no exists
                    if (!row.original.invoice_no) return "-";
                    const invoiceDate = getValue();
                    return invoiceDate ? moment(invoiceDate).format("DD MMM YYYY") : "-";
                },
                enableColumnFilter: false,
                enableGrouping: false,
                // enableSorting: true,
                footer: ({ table }) => <>{/* <span className="font-semibold text-md">Total</span> */}</>,
            },

            {
                accessorKey: "_ts_invoice_due",
                header: "Invoice Due Dt.",
                cell: ({ row, getValue }) => {
                    if (!row.original.invoice_no) return "-";

                    const dueDate = getValue();
                    return dueDate ? moment(dueDate).format("DD MMM YYYY") : "-";
                },
                enableColumnFilter: false,
                enableGrouping: false,
                // enableSorting: true,
                footer: ({ table }) => <>{/* <span className="font-semibold text-md">Total</span> */}</>,
            },
        ],
        [],
    );

    // Helper to filter data for 2025 and above, and unpaid if checked
    const filteredData = React.useMemo(() => {
        console.warn("Filtering Data");
        // console.warn("Filtering Data:", data, applyYearFilter, showUnpaidOnly);

        let result = data;

        console.log("Before filtering:", data);
        console.log("applyYearFilter:", applyYearFilter, "showUnpaidOnly:", showUnpaidOnly, "selectedClient:", selectedClient);
        console.log("After filtering:", result);

        if (applyYearFilter) {
            console.log("Applying year filter for 2025 and above");
            result = result.filter((row) => Number(row.year) >= 2025);
        }
        if (showUnpaidOnly) {
            console.log("Applying unpaid only filter");
            result = result.filter((row) => Number(row.payment) === 0);
        }
        if (selectedClient !== "all") {
            console.log("Applying client filter for:", selectedClient);
            result = result.filter((row) => String(row?.cid) === selectedClient);
        }
        return result;
    }, [data, applyYearFilter, showUnpaidOnly, selectedClient]);

    // Utility to format all date fields in a row (add this inside your component)
    function formatDatesForDownload(row: any) {
        const dateFields = ["period_start", "period_end", "_d", "_ts_invoice", "_ts_invoice_due"];
        const formattedRow = { ...row };
        dateFields.forEach((field) => {
            if (formattedRow[field]) {
                formattedRow[field] = moment(formattedRow[field]).format("YYYY-MM-DD");
            }
        });
        return formattedRow;
    }

    // console.log("Filtered Data:", filteredData);

    useEffect(() => {
        console.log("Data changed:", data);
        console.log("Filtered Data changed:", filteredData);
    }, [data, filteredData]);

    return (
        <>
            <main>
                <Breadcrums breadcrumLinks={paymentsGenerateInvoiceBreadcrums} commands={paymentsCommands} groups={["Actions", "Statement"]}></Breadcrums>
                <PageTitle title="Payment Invoice(s)" summary="turning services into value" preSummary="Sealing the deal with a payment invoice"></PageTitle>

                <section className={sectionClass}>
                    {/* Show duplicate invoice numbers if any */}
                    {/* {duplicateInvoices.length > 0 && (
                        <div className="p-3 mb-4 text-yellow-800 bg-yellow-100 border border-yellow-400 rounded">
                            <strong>Warning:</strong> Duplicate Invoice Numbers found:
                            <ul className="ml-6 list-disc">
                                {duplicateInvoices.map((inv, idx) => (
                                    <li key={idx}>{inv?.invoice_no}</li>
                                ))}
                            </ul>
                        </div>
                    )} */}
                    {/* Checkbox for year filter */}
                    <div className="mb-4">
                        <label className="inline-flex items-center">
                            <input type="checkbox" checked={applyYearFilter} onChange={() => setApplyYearFilter((v) => !v)} className="w-4 h-4 text-indigo-600 transition duration-150 ease-in-out form-checkbox" />
                            <span className="ml-2">Show only data for 2025 and above</span>
                        </label>
                    </div>
                    {/* Checkbox for unpaid only filter */}
                    <div className="mb-4">
                        <label className="inline-flex items-center">
                            <input type="checkbox" checked={showUnpaidOnly} onChange={() => setShowUnpaidOnly((v) => !v)} className="w-4 h-4 text-indigo-600 transition duration-150 ease-in-out form-checkbox" />
                            <span className="ml-2">Show unpaid invoices only</span>
                        </label>
                    </div>

                    {/* Dropdown to filter employees by status */}
                    <div className="mb-4">
                        <label>Filter Employees(All/Active/inactive):</label>
                        <select onChange={(e) => setActiveStatus(e.target.value as "all" | "active" | "inactive")} value={activeStatus} className="block px-3 py-2 mt-1 bg-white border border-gray-300 rounded-md shadow-sm w-96 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                            <option value="all">All Employees</option>
                            <option value="active">Active Employees</option>
                            <option value="inactive">Inactive Employees</option>
                        </select>
                    </div>

                    {/* Client filter dropdown */}
                    <div className="mb-4">
                        <label>Filter by Client:</label>
                        <select onChange={(e) => setSelectedClient(e.target.value)} value={selectedClient} className="block px-3 py-2 mt-1 bg-white border border-gray-300 rounded-md shadow-sm w-96 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                            <option value="all">All Clients</option>
                            {clients.map((client) => (
                                <option key={client.id || client.name} value={client.id}>
                                    {client.name}
                                </option>
                            ))}
                        </select>
                        {clients.length > 0 && (
                            <div className="text-xs text-gray-500 mt-1">
                                {clients.length} clients loaded
                            </div>
                        )}
                    </div>

                    {/* Employee filter dropdown */}
                    {/* <div className="mb-4">
                        <label>Filter by Employee:</label>
                        <select onChange={(e) => setSelectedClient(e.target.value)} value={selectedClient} className="block px-3 py-2 mt-1 bg-white border border-gray-300 rounded-md shadow-sm w-96 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                            <option value="all">All Employees</option>
                            {data && data.length > 0 && Array.from(new Set(data.map((row) => row.name).filter(Boolean))).sort().map((employee) => (
                                <option key={employee} value={employee}>{employee}</option>
                            ))}
                        </select>
                        {data && data.length > 0 && (
                            <div className="text-xs text-gray-500 mt-1">
                                {Array.from(new Set(data.map((row) => row.name).filter(Boolean))).length} unique employees found
                            </div>
                        )}
                    </div> */}

                    {/* Space between filters */}
                    <div className="mb-6"></div>

                    {/* Pass filtered employees to CommonFilters */}
                    <div className="mb-4">
                        <CommonFilters
                            key={`${billingPeriod}-${activeStatus}-${applyYearFilter}-${selectedClient}-${showUnpaidOnly}`} // Force remount when filters change
                            people={people.filter((employee) => {
                                // Filter by active status first
                                const statusMatch = activeStatus === "active" ? employee?.active === 1 && employee.entity === "erp360" : activeStatus === "inactive" ? employee?.active === 0 && employee.entity === "erp360" : employee?.entity === "erp360";

                                // If billingPeriod is "all", don't filter further
                                if (billingPeriod === "all") return statusMatch;

                                // Only include employees who have at least one invoice with the selected billing period and year >= 2025
                                const hasBillingPeriod = filteredData.some(
                                    (row) => row.billing_period === billingPeriod && row.name === employee.entity, // Adjust this if your matching key is different
                                );
                                return statusMatch && hasBillingPeriod;
                            })}
                            applyFilters={applyFilters}
                            clientId={selectedClient !== "all" ? selectedClient : undefined}
                            billingPeriod={billingPeriod}
                            employeeStatus={activeStatus}
                            yearLimit={applyYearFilter} // Pass year limit if filter is applied
                        /> 
                    </div>

                    <div className="mb-4">
                        <label>Filter by Billing Period:</label>
                        <select onChange={(e) => setBillingPeriod(e.target.value as "all" | "Weekly" | "Monthly" | "Monthly Itemized")} value={billingPeriod} className="block px-3 py-2 mt-1 bg-white border border-gray-300 rounded-md shadow-sm w-96 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                            <option value="all">All</option>
                            <option value="Weekly">Weekly</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Monthly Itemized">Monthly Itemized</option>
                        </select>
                    </div>

                    {!isLoading && data && filteredData?.length > 0 && <TanstackTable key={tableKey} data={billingPeriod === "all" ? filteredData : filteredData?.filter((row) => row.billing_period === billingPeriod)} columns={columns} downloadBtn={true} formatDataForDownload={formatDatesForDownload} />}
                    {!isLoading && filteredData?.length <= 0 && <div className="my-5">No records found</div>}
                    {isLoading && <div className="my-5">Loading... </div>}
                </section>
            </main>
        </>
    );
}
